import { createStore, applyMiddleware,compose} from "redux";
import thunk from "redux-thunk";
import {createLogger} from "redux-logger"
import appReducer from "./reducers";
import { configureStore } from "@reduxjs/toolkit";

window.newConsole = {
    logs:[],
    log: function() {
       
        //this.logs.push(message)
        this.logs.push(Array.from(arguments));
        // do whatever custom thing you want
    }
}



const logger = createLogger({
  level:"log",
  logger:window.newConsole,
  diff:true
  
  
});
const estadoInicial = {};
const middleware = [thunk,logger];

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store2 = configureStore({
  reducer:appReducer
})

const store = createStore(
  appReducer,
  estadoInicial, 
  composeEnhancers(applyMiddleware(...middleware))
)

export default store2

